/* esm.sh - esbuild bundle(@lit/reactive-element@1.6.3/decorators/state) esnext production */
import{property as r}from"/v135/@lit/reactive-element@1.6.3/esnext/decorators/property.js";function o(t){return r({...t,state:!0})}export{o as state};
/*! Bundled license information:

@lit/reactive-element/decorators/state.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/
//# sourceMappingURL=state.js.map